<template>
  <div>
    <v-progress-linear v-if="$apollo.loading" indeterminate />
    <v-row v-else>
      <v-col>
        <metric-card label="Transitioned payfast clients last 15 days" :total="subscriptions.length" />

        <vue-json-to-csv
          :json-data="dataString"
          :csv-title="`${$moment().format('YYYY_MM_DD')}_payfast_transitioned_subscriptions`"
        >
          <v-btn class="mt-2">
            Download CSV
          </v-btn>
        </vue-json-to-csv>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { PAYFAST_TRANSITION_QUERY } from "@/graphql/queries/subscriptions";
import VueJsonToCsv from "vue-json-to-csv";
import MetricCard from "@/components/shared/MetricCard";

export default {
  name: "PayfastTransitionedSubscriptions",
  components: {
    MetricCard,
    VueJsonToCsv,
  },
  data() {
    return {
      subscriptions: [],
      loadingCSV: false,
      dataString: "",
    };
  },
  apollo: {
    subscriptions: {
      query: PAYFAST_TRANSITION_QUERY,
      update(data) {
        this.dataString = data.payfastTransitionedSubscriptions.map((item) => {
          return {
            firstName: item.user.firstName,
            lastName: item.user.lastName,
            email: item.user.email,
            phone: item.user.userProfile.phone,
            country: item.user.userProfile.country?.code,
            startDate: item.startDate,
          };
        });
        return data.payfastTransitionedSubscriptions;
      },
    },
  },
};
</script>
